import { ActionEntry } from "../../ActionEntries";

export const ApplyActionVisibility = (
  action: ActionEntry,
  newActions: Map<string, ActionEntry>,
  actionOrder: string[]
) => {
  const newActionOrder = [...actionOrder];

  // If actionOrder is empty, initialize it with all currently visible actions
  // (excluding BrickPack and BuySet actions which are not displayed in Actions module)
  if (newActionOrder.length === 0) {
    newActions.forEach((a, id) => {
      if (a.visible && !a.isBrickpack && a.type !== "BuySet") {
        newActionOrder.push(id);
      }
    });
  }

  // Now handle newly visible actions
  for (let i = 0; i < action.actionVisibility.length; i++) {
    const actionId = action.actionVisibility[i].actionId;
    const changableAction = newActions.get(actionId);

    if (changableAction && changableAction.visible === false) {
      changableAction.visible = true;

      // Append to end of actionOrder if:
      // 1. Not already present
      // 2. Not a BrickPack action
      // 3. Not a BuySet action
      if (
        !newActionOrder.includes(actionId) &&
        !changableAction.isBrickpack &&
        changableAction.type !== "BuySet"
      ) {
        newActionOrder.push(actionId);
      }
    } else if (!changableAction) {
      console.error(
        `[ApplyActionVisibility] Action ${actionId} not found in actions Map!`
      );
    }
  }

  return { newActions, newActionOrder };
};
